/* ----------------------------------------
    App generator
---------------------------------------- */

import StoreDispatcher from '@service/StoreDispatcher';

export default function * UserGenerator() {
    yield StoreDispatcher.fetchUser();
}